import storage from 'store'
import expirePlugin from 'store/plugins/expire'
import {ACCESS_TOKEN, TENANT, TOKEN_NAME} from '@/store/mutation-types'

storage.addPlugin(expirePlugin)

const websocket = {
  state: {
    ws: undefined,
    heartbeatTask: undefined,
    heartbeatInterval: 1000 * 60,
  },

  mutations: {
    SET_WS: (state, ws) => {
      state.ws = ws
    }
  },

  actions: {
    // 登录
    initWebSocket ({ commit, state }, userInfo) {
      return new Promise((resolve, reject) => {
        const tenant = storage.get(TENANT)
        const url = process.env.VUE_APP_API_ADMIN_URL.replace("#tenant#", tenant).replace('http', 'ws').replace('https', 'wss').replace('/api', '')
        let websocket = new WebSocket(url + `/im/message?${storage.get(TOKEN_NAME)}=${storage.get(ACCESS_TOKEN)}&tenant=${tenant}`); // 创建WebSocket连接

        // WebSocket连接打开时的处理函数
        websocket.onopen = () => {
          console.log('websocket onopen')

          let data = {
            senderId:  userInfo.id,
            messageType: 1,
            userId:  userInfo.id
          }
          websocket.send(JSON.stringify(data));

          //开启心跳
          if (state.heartbeatTask) {
            clearInterval(state.heartbeatTask)
          }
          state.heartbeatTask = setInterval(() => {
            let data = {
              messageType: 2,
              content: 'ping'
            }
            //发送心跳
            websocket.send(JSON.stringify(data))
          }, state.heartbeatInterval);

        }

        // 收到WebSocket消息时的处理函数
        websocket.onmessage = (event) => {
          // console.log('websocket onmessage', event)
          const data = JSON.parse(event.data)
          if (data.messageType !== 4) {
            window.dispatchEvent(new CustomEvent('imMessage', {detail: {
              data: event.data
            }}))
          }
        }

        websocket.onclose = () => {
          console.log('websocket onclose', event)
        }

        commit('SET_WS', websocket)

        resolve()
      })
    }
  }
}

export default websocket
